import React from 'react'

export default function TermsAndConditionsPage() {
  return (
    <div className="max-w-4xl mx-auto p-6">
      <h1 className="text-3xl font-bold mb-4">Terms & Conditions</h1>

      <div className="space-y-4 text-gray-800 text-sm leading-relaxed">
        <p>
          <strong>Welcome to KIED!</strong> You agree to comply with these terms
          and conditions by accessing this website. If you do not agree with
          these terms, do not use KIED.
        </p>

        <p>
          <strong>Cookies:</strong> Our website uses cookies. By accessing KIED,
          you agree to our use of cookies in accordance with our Privacy Policy.
        </p>

        <p>
          <strong>License:</strong> All intellectual property rights on this
          website and its material belong to KIED and/or its licensors. You may
          only view, download, and print pages from the website for personal
          use, subject to the restrictions outlined below.
        </p>

        <p>
          <strong>You must not:</strong>
        </p>
        <ul className="list-disc list-inside space-y-1 ml-4">
          <li>Republish or sell website material</li>
          <li>Display website material in the public</li>
          <li>Use website material for commercial purposes</li>
          <li>Edit or modify website material</li>
          <li>
            Redistribute website material, except for specifically designated
            content
          </li>
        </ul>

        <p>
          <strong>Acceptable use:</strong> Do not use this website in any way
          that may harm the website, impair accessibility, or conduct any
          unlawful, fraudulent, or harmful activity. Do not use this website to
          distribute malicious computer software, or engage in systematic or
          automated data collection without our express written consent.
        </p>

        <p>
          <strong>Restrictions:</strong> We reserve the right to restrict access
          to certain areas of this website.
        </p>
      </div>
    </div>
  )
}
